<div *ngIf="findZipCode === null">
  <div class="w-full small-3 cell bg-red-600 mt-3 p-1 text-center text-white">
    Out Of Service Area
  </div>
</div>
<div *ngIf="findZipCode != null && findZipCode.travelFee > 0">
  <div class="w-full small-3 cell bg-orange-600 mt-1 p-1 text-center text-white">
    Additional travel fee {{ findZipCode?.travelFee | currency: 'USD' }}
  </div>
  @if (findZipCode.surcharge > 0) {
    <div class="w-full small-3 cell bg-gray-600 mt-1 p-1 text-center text-white">
      Area Surcharge: +{{ findZipCode?.surcharge | currency: 'USD' }}
    </div>
  }
</div>
<div *ngIf="findZipCode != null && findZipCode.travelFee === 0">
  <div class="w-full small-3 cell bg-green-600 mt-1 p-1 text-center text-white">
    Within Local Service Area
  </div>
  @if (findZipCode.surcharge > 0) {
    <div class="w-full small-3 cell bg-gray-600 mt-1 p-1 text-center text-white">
      Area surcharge: +{{ findZipCode?.surcharge | currency: 'USD' }}
    </div>
  }
</div>
